"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const RoleHelper_1 = tslib_1.__importDefault(require("../role/RoleHelper"));
class RoleUtil {
    static isCitizen(moduleContext) {
        return RoleHelper_1.default.Citizen.equals(moduleContext.getUserContext().getSelectedRole());
    }
}
exports.default = RoleUtil;
//# sourceMappingURL=RoleUtil.js.map